import React from "react";
import "./smallSpinner.css";

const spinner = (props) => {
  return <div class="lds-dual-ring"></div>;
};

export default spinner;
